import React from "react";


function DressCode() {
    return (
        <div>
            
            <div className="container" style={{ backgroundImage: 'url(./images/event.jpeg)', marginTop: '100px', marginBottom: '100px', padding: '50px', backgroundSize: 'cover', backgroundAttachment: 'fixed', borderRadius: '25px', boxShadow: '0px 0px 1000px maroon ',height:'80vh',display:'flex',alignItems:'center',justifyContent:'center' }}>

               

                <div className="row" style={{  }}>
                    <div className="col-md-6" style={{ background: '#ffeccaf6', padding: '50px', borderRadius: '20px',border:'10px solid maroon' }}>
                        <div className="row" style={{ marginBottom: '25px', borderBottom: '1px solid orange', paddingBottom: '15px', paddingTop: '15px', background: 'orange' }}>
                            <div className="col-md-12 middle">
                                <center><p className="enquiry">Dress Code For Men</p> </center>
                            </div>
                        </div>
                        <div className="row">
                            <div class="row col-md-12">
                                <h4 className="dresscodekiosk">Wear Dhoti and Angavastram (not compulsory) and should not cover anything on the head.</h4>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6" style={{ background: '#ffeccaf6', padding: '50px', borderRadius: '20px',border:'10px solid maroon'  }}>
                        <div className="row" style={{ marginBottom: '25px', borderBottom: '1px solid orange', paddingBottom: '15px', paddingTop: '15px', background: 'orange' }}>
                            <div className="col-md-12 middle">
                                <center><p className="enquiry">Dress code for women</p> </center>
                            </div>
                        </div>
                        <div className="row">
                            <div class="row col-md-12">
                                <h4 className="dresscodekiosk">can wear Sarees, wrap a Dhotie above the pant, Pavadas with blouse or other coverings as appropriate to their age. Salvar sets and other modern dresses are not allowed. No other types of dress should be worn or taken inside the temple.</h4>
                            </div>
                        </div>
                    </div>
                </div>
               


                

            </div>
        </div>
    );
}

export default DressCode;